import React, { createContext, useContext, useState, useEffect } from 'react';
import { BrowserRouter, useRoutes, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { NotificationsProvider } from 'tailwind-notifications-react'
import 'tailwind-notifications-react/dist/index.css'
import { MerchPage } from './pages/merch/MerchPage';
import { MerchDetailPage } from './pages/merch/MerchDetailPage';
import { NotFoundPage } from './pages/not-found/main';
import { MainPage } from './pages/main/main';
import { LoginPage } from './pages/login/LoginPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { CreateProductPage } from './pages/dashboard/CreateProductPage';
import { EditProductPage } from './pages/dashboard/EditProductPage';
import { ProductsListPage } from './pages/dashboard/ProductsListPage';
import { OrdersListPage } from './pages/dashboard/OrdersListPage';
import { OrderPage } from './pages/dashboard/OrderPage';
import { TagsPage } from './pages/dashboard/TagsPage';
import { SettingsPage } from './pages/dashboard/SettingsPage';
import { CouponsPage } from './pages/dashboard/CouponsPage';
import { CartProvider } from "./context/CartContext";
import { CartPage } from './pages/merch/CartPage';
import { ServiceRedirectPage } from './pages/merch/ServiceRedirectPage';
import { PaymentPage } from './pages/merch/PaymentPage'
import { UploadsPage } from './pages/uploads/UploadsPage'
import { ContactsPage } from './pages/contacts/ContactsPage'
import { VideosPage } from './pages/videos/VideosPage'
import { ConcertsPage } from './pages/concerts/ConcertsPage';
const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedUser = jwtDecode(token);
      if (decodedUser.exp * 1000 < Date.now()) {
        localStorage.removeItem('token');
        setUser(null);
      } else {
        setUser(decodedUser);
      }
    }
  }, []);
  const login = async (credentials) => {
    const response = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });
    if (response.ok) {
      const data = await response.json();
      setUser(data.user);
      localStorage.setItem('token', data.token);
      return true;
    }
    return false;
  };
  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
  };
  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
export const useAuth = () => useContext(AuthContext);

const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem('token');

  if (!token) return <Navigate to="/login" />;

  try {
    const decoded = jwtDecode(token);
    if (decoded.exp * 1000 < Date.now()) {
      localStorage.removeItem('token');
      return <Navigate to="/login" />;
    }
    return element;
  } catch (e) {
    localStorage.removeItem('token');
    return <Navigate to="/login" />;
  }
};


const Routes = () => {
  const routes = useRoutes([
    { path: "/", element: <MainPage /> },
    { path: "/contacts", element: <ContactsPage /> },
    { path: "/videos", element: <VideosPage /> },
    { path: "/merch", element: <MerchPage /> },
    { path: "/login", element: <LoginPage /> },
    { path: "/uploads/:photo", element: <UploadsPage /> },
    { path: "/merch", element: <MerchPage /> },
    { path: "/merch/product", element: <MerchDetailPage /> }, // merchdetailpage
    { path: "/payment/:id", element: <PaymentPage /> },
    { path: "/merch/cart", element: <CartPage /> }, // cartpage
    { path: "/concerts", element: <ConcertsPage /> },
    { path: "/paymentstatus/:status", element: <ServiceRedirectPage /> },
    {
      path: "/dashboard",
      element: <ProtectedRoute element={<DashboardPage />} />,
    },
    {
      path: "/dashboard/create-product",
      element: <ProtectedRoute element={<CreateProductPage />} />,
    },
    {
      path: "/dashboard/products",
      element: <ProtectedRoute element={<ProductsListPage />} />,
    },
    {
      path: "/dashboard/orders",
      element: <ProtectedRoute element={<OrdersListPage />} />,
    },
    {
      path: "/dashboard/order",
      element: <ProtectedRoute element={<OrderPage />} />,
    },
    {
      path: "/dashboard/edit-product",
      element: <ProtectedRoute element={<EditProductPage />} />,
    },
    {
      path: "/dashboard/tags",
      element: <ProtectedRoute element={<TagsPage />} />,
    },
    {
      path: "/dashboard/settings",
      element: <ProtectedRoute element={<SettingsPage />} />,
    },
    {
      path: "/dashboard/coupons",
      element: <ProtectedRoute element={<CouponsPage />} />,
    },
    { path: "*", element: <NotFoundPage /> },
  ]);
  return routes;
};
const App = () => {
  return (
<NotificationsProvider>
  <CartProvider>
    <BrowserRouter>
      <Routes>
      </Routes>
    </BrowserRouter>
  </CartProvider>
</NotificationsProvider>
  );
};
export default App;
